import { LocalStorage } from "@/service/local-storage";

export class LastViewedProducts {
	private static instance: LastViewedProducts;
	private readonly lastViewedProducts: string[];

	private constructor(private localStorage: LocalStorage) {
		this.lastViewedProducts = this.getLastViewedProductsFromStorage();
	}

	static getInstance(): LastViewedProducts {
		if (LastViewedProducts.instance == null) {
			LastViewedProducts.instance = new LastViewedProducts(LocalStorage.getInstance());
		}
		return LastViewedProducts.instance;
	}

	add(productKey: string) {
		// prevent duplicate keys within the last viewed products array.
		this.remove(productKey);

		this.lastViewedProducts.unshift(productKey);
		if (this.lastViewedProducts.length > 5) {
			this.lastViewedProducts.pop();
		}
		this.save();
	}

	remove(productKey: string) {
		const indexForProductByKey = this.lastViewedProducts.indexOf(productKey);
		if(indexForProductByKey > -1) {
			this.lastViewedProducts.splice(indexForProductByKey, 1);
		}

		this.save();
	}

	getAllExcept(except: string): string[] {
		return this.lastViewedProducts.filter(key => key !== except);
	}

	private getLastViewedProductsFromStorage(): string[] {
		return this.localStorage.get("lastViewedProducts") || [];
	};

	private save() {
		this.localStorage.set("lastViewedProducts", this.lastViewedProducts);
	}
}